import React from 'react';
import { useAuth } from '../../hooks/auth';
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router-dom';
import { checkOriginDev, getUrlSecurity } from '../../utils/util';

const Security: React.FC = () => {
    const { signInToken } = useAuth();
    const history = useHistory();
    const cookies = new Cookies();
    const urlSecurity = getUrlSecurity(window);

    if ((cookies.get('FCA-security') !== undefined && cookies.get('FCA-security') !== '')) {
        signInToken({ token: cookies.get('FCA-security') });
    } else if (checkOriginDev(window)) {
        history.push("/Sign");
    } else {
        window.location.href = urlSecurity !== undefined ? urlSecurity : '';
    }

    return (
        <div></div>
    );
}

export default Security;
